var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResolvingRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#resolving-right_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.33,
  d: "M8.184.673c1.134 0 2.06.92 2.06 2.06 0 .868.705 1.573 1.572 1.574h5.46c1.133 0 2.059.92 2.059 2.06v9.091c0 1.134-.92 2.06-2.06 2.06h-5.459c-1.134 0-2.06-.92-2.06-2.06 0-.867-.705-1.573-1.572-1.573H1.15v5.207c0 .133-.11.243-.243.243a.245.245 0 0 1-.243-.243V2.725c0-1.082.845-1.973 1.907-2.052zm2.06 9.084h3.633v2.303h-3.634v3.39c0 .867.706 1.573 1.573 1.573h3.391V13.39h3.633V8.427h-3.633V4.793h-4.964zM4.792 4.793H1.151v4.964h3.642v3.633h4.964V8.427H6.115V6.123h3.642v-3.39c0-.867-.706-1.573-1.573-1.573H4.793z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "resolving-right_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgResolvingRight;